import { IFormReadonlyModelAccessor } from "../../Form/IFormModelAccessor";
import { FormStore } from "../Store/CandyStore";
import { BindingPath, ModelValue, ViewModel } from "../CoreTypes";
import { currentViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { getNestedNodeViewModels, getViewModel, NodeViewModel } from "../Store/FormViewModel";
import { PathUtils } from "../PathUtils/PathUtils";
import { AbsoluteModelPath, convertToAbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { ModelHunk } from "./ModelHunk";
import { ModelChunk } from "./ModelChunk";

export class ReadonlyModelOverStore implements IFormReadonlyModelAccessor {
    private readonly store: FormStore;

    public constructor(store: FormStore) {
        this.store = store;
    }

    public getBatch(nodePathPrefixIn: BindingPath | AbsoluteModelPath): ModelChunk {
        const nodePathPrefix = convertToAbsoluteModelPath(nodePathPrefixIn);
        const state = this.store.getState();
        const modelValue = currentViewModelSelect.node(state, nodePathPrefix);

        function fillModelChunk(path: AbsoluteModelPath, nodeViewModel: NodeViewModel, result: ModelChunk): ModelChunk {
            const viewModel = getViewModel(nodeViewModel);
            if (viewModel != undefined) {
                ModelHunk.set(result, path, viewModel);
            }
            for (const [key, value] of getNestedNodeViewModels(nodeViewModel)) {
                fillModelChunk(path.joinWith(key), value, result);
            }
            return result;
        }

        const values = fillModelChunk(nodePathPrefix, modelValue, ModelHunk.create());

        return values;
    }

    public getChildren(bindingPath: BindingPath | AbsoluteModelPath): string[] | undefined {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.getViewModelField(bindingPath, "children");
    }

    public getValue(bindingPath: BindingPath | AbsoluteModelPath): string | undefined {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.getViewModelField(bindingPath, "value");
    }

    public getViewModel(bindingPath: BindingPath | AbsoluteModelPath): ViewModel | undefined {
        const state = this.store.getState();
        return currentViewModelSelect.pathViewModelOrUndefined(state, bindingPath);
    }

    public getViewModelField(bindingPath: BindingPath | AbsoluteModelPath, name: string): ModelValue | undefined {
        const path = convertToAbsoluteModelPath(bindingPath);
        if (PathUtils.isPicklistFieldValueName(name)) {
            const viewModel = this.getViewModel(path);
            return viewModel?.picklist?.[PathUtils.getPicklistFieldName(name)];
        }

        return this.getViewModelFieldInternal(path, name);
    }

    private getViewModelFieldInternal(path: AbsoluteModelPath, fieldName: string): ModelValue {
        // @ts-ignore
        return currentViewModelSelect.pathViewModelOrUndefined(this.store.getState(), path)?.[fieldName];
    }
}
